import { FormHelperText } from "@chakra-ui/react";
import { format } from "date-fns";

import { FORMAT_UI_DATE } from "@/common/constants";

interface CurrencyExchangeDateProps {
    date: Date;
}

const CurrencyExchangeDate: React.FC<CurrencyExchangeDateProps> = ({ date }) => (
    <FormHelperText>{format(date, FORMAT_UI_DATE)}</FormHelperText>
);

export default CurrencyExchangeDate;
